export default {
    measure_1: 'Deaths',
    measure_2: 'DALYs',
    measure_3: 'YLDs',
    measure_4: 'YLLs',
    measure_5: 'Prevalence',
    measure_6: 'Incidence',
    measure_7: 'Remission',
    measure_8: 'Duration',
    measure_9: 'Excess mortality rate',
    measure_10: 'Prevalence * excess mortality rate',
    measure_11: 'Relative risk',
    measure_12: 'Standardized mortality ratio',
    measure_13: 'With-condition mortality rate',
    measure_14: 'All-cause mortality rate',
    measure_15: 'Cause-specific mortality rate',
    measure_16: 'Other cause mortality rate',
    measure_17: 'Case fatality rate',
    measure_18: 'Proportion',
    measure_19: 'Continuous',
    measure_20: 'Survival Rate',
    measure_21: 'Disability Weight',
    measure_22: 'Chronic Prevalence',
    measure_23: 'Acute Prevalence',
    measure_24: 'Acute Incidence',
    measure_25: 'Maternal mortality ratio',
    measure_26: 'Life expectancy',
    measure_27: 'Probability of death',
    measure_28: 'HALE (Healthy life expectancy)',
    measure_29: 'Summary exposure value',
    measure_30: 'Life expectancy no-shock hiv free',
    measure_31: 'Life expectancy no-shock with hiv',
    measure_32: 'Probability of death no-shock hiv free',
    measure_33: 'Probability of death no-shock with hiv',
    measure_34: 'Mortality risk',
    measure_35: 'Short term prevalence',
    measure_36: 'Long term prevalence',
    measure_37: 'Life expectancy decomposition by cause',
    measure_38: 'Birth prevalence',
    measure_39: 'Susceptible population fraction',
    measure_40: 'With Condition population fraction',
    measure_41: 'Susceptible incidence',
    measure_42: 'Total incidence',
    measure_43: 'HAQ Index (Healthcare Access and Quality Index)',
    measure_44: 'Population',
    measure_45: 'Fertility',
    measure_100: 'Patient Need',
    measure_4096: 'Beds Needed - All',
    measure_4097: 'Beds Needed - ICU',
    measure_4098: 'Invasive Ventilators Needed',
    measure_4099: 'Hospital Admissions',
    measure_4100: 'New ICU patients',
    measure_4101: 'Beds Needed - Over Capacity - All',
    measure_4102: 'Beds Needed - Over Capacity - ICU',
    measure_4103: 'Deaths',
    measure_4104: 'Deaths - Cumulative (as reported)',
    measure_4105: 'Deaths (smoothed)',
    measure_4106: 'Deaths - Cumulative (smoothed)',
    measure_4107: 'Change in mobility',
    measure_4108: 'Tests per day',
    measure_4109: 'Infections - Confirmed',
    measure_4110: 'Infections - Estimated',
    measure_4111: 'Infections - Cumulative - Estimated',
    measure_4112: 'Seroprevalence',
    measure_4113: 'Covid-19 - Test Protocol Threshold 1',
    measure_4114: 'Covid-19 - Test Protocol Threshold 2',
    measure_4115: 'Co-prevalence',
    measure_4116: 'Deaths - Reported',
    measure_4117: 'Deaths - Cumulative - Reported',
    measure_4118: 'Deaths - Reported (smoothed)',
    measure_4119: 'Deaths - Cumulative - Reported (smoothed)',
    measure_4120: 'Covid-19 - R - Effective',
    measure_4121: 'Covid-19 - Pneumonia Seasonality',
    measure_4122: 'Covid-19 - Infection Fatality',
    measure_4123: 'Covid-19 - Infection Detection',
    measure_4124: 'Covid-19 - Infection Hospitalization',
    measure_4125: 'Covid-19 - Daily infections',
    measure_4126: 'Covid-19 - Cumulative - all vaccinated',
    measure_4127: 'Covid-19 - Cumulative - all fully vaccinated',
    measure_4128: 'Covid-19 - Cumulative - all effectively vaccinated',
    measure_4129: 'Covid-19 - Daily hospital beds',
    measure_4130: 'Covid-19 - Excess Deaths - Cumulative',
    measure_4131: 'Covid-19 - Excess Deaths - Estimated',
    measure_4132: 'Covid-19 - Mandates Intensity',
    measure_10002: 'One-year overall survival',
    measure_10004: 'One-year next-treatment-free survival',
    measure_10005: 'Cases',
    measure_10006: 'Google Trends',
};
